<template lang="pug">
  yz-card.pa-6.d-flex.flex-column.align-center.justify-center(outlined, :border-color="borderColor" v-bind="mergedAttrs" :style="`gap: ${getGap}`")
    slot(name="icon")
      yz-icon(:size="iconSize" :color="getIconColor") {{ icon }}

    div
      slot(name="title")
        .yz-medium-body-sm.text-neutral-700.text-center.mb-1(v-if="title") {{ title }}
      slot(name="description")
        .yz-medium-body-sm.text-neutral-500.text-center.font-normal(v-if="description") {{ description }}

    slot(name="action")
      yz-btn(v-if="actionLabel" :label="actionLabel" :size="actionSize" :color="actionColor" :text-color="actionTextColor" @click="onActionClick")

</template>

<script>
export default {
  name: "YzEmptyStateCard",
  inheritAttrs: false,
  props: {
    borderStyle: {
      type: String,
      default: 'dashed',
      validator: value => ['solid', 'dashed', 'dotted'].includes(value)
    },
    borderColor: {
      type: String,
      default: 'yz-neutral-400'
    },
    gap: {
      type: [String, Number],
      default: '10px'
    },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: '32px'
    },
    iconColor: {
      type: String,
      default: 'yz-neutral-500'
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    actionLabel: {
      type: String,
      default: null
    },
    actionSize: {
      type: String,
      default: 'sm'
    },
    actionColor: {
      type: String,
      default: 'primary'
    },
    actionTextColor: {
      type: String,
      default: null
    }
  },
  computed: {
    mergedAttrs() {
      // eslint-disable-next-line no-unused-vars
      const {tile, shaped, ...attrs} = this.$attrs
      // handle border style
      attrs.borderStyle = this.borderStyle

      return attrs
    },
    getIconColor () {
      if (this.iconColor.startsWith('#')) {
        return this.iconColor
      } else if (this.iconColor.startsWith('var(')) {
        return this.iconColor
      } else if (this.iconColor.startsWith('yz-')) {
        return `var(--${this.iconColor})`
      } else {
        return `var(--yz-${this.iconColor})`
      }
    },
    getGap () {
      return typeof this.gap === 'number' ? `${this.gap}px` : this.gap
    }
  },
  methods: {
    onActionClick () {
      this.$emit('action-click')
    }
  }
}
</script>

<style scoped>

</style>